import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../utils/axiosInstance";

export const fetchNpfuafLabels = createAsyncThunk(
    "npfuaf/fetchNpfuafLabels",
    async ({status, sort}) => {
    const response = await axiosInstance.get("/api/npfuaflabel/npfuaf-labeladdress", {  
            params: { status, sort },
        });
        return response.data;
    }
);
const npfuafSlice = createSlice({
    name: "npfuaflabel",
    initialState: {
        npfuafLabels: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchNpfuafLabels.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNpfuafLabels.fulfilled, (state, action) => {
                state.npfuafLabels = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(fetchNpfuafLabels.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default npfuafSlice.reducer;
